import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";

import { DialogWirelessTicketsComponent } from "../../../../../components/dialogs/dialog-wireless-tickets/dialog-wireless-tickets";
import { AnalyticsService } from "../../../../../services/analytics.service";
import { AnalyticsAction, AnalyticsModule } from "../../../../../services/analytics.types";
import { WirelessTicket } from "../../../../models/wireless-ticket";
import { TicketsBadgeButton } from "../tickets-badge-button/tickets-badge-button";

@Component({
  selector: "wireless-tickets-item",
  templateUrl: "wireless-tickets-item.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TicketsBadgeButton],
})
export class WirelessTicketsItem {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private analytics = inject(AnalyticsService);

  protected tickets = input.required<WirelessTicket[]>();
  protected scope = input<"location" | "organisation">("location");

  openTicketsDialog() {
    this.analytics.trackFeature(AnalyticsModule.Wireless, AnalyticsAction.InspectTicket, this.scope());
    this.dialog
      .open(DialogWirelessTicketsComponent, {
        data: { tickets: this.tickets(), scope: this.scope() },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result === "viewAll") {
          this.router.navigate(["/diensten/Wireless"], { state: { openTickets: true } });
        }
      });
  }
}
